<template>
  <div class="payChoess">
    <div class="navbar_style" :class="$store.state.user.isNested && 'navbar_style_nested'">
      <Icon class="navbar_icon" name="arrow-left" @click="$router.back(1)"/>
      <span>{{ androidData.vaType == 1 ? l.bank_pay_immediately : l.router_pay_rollover }}</span>
      <div class="icon_box"></div>
    </div>
  </div>
</template>

<script>
import {Icon, Toast} from "vant";
import l from "@/locales";
import {
  // getva,
  loanappqueryDetail} from "@/services/order";

export default {
  name: "payChoess",
  components: {Icon},
  data() {
    return {
      resData: {},
      androidData: {},
      curItem: "",
      l: {...l.repayMethods, ...l.router},
      payInfo: {},
    };
  },
  created() {
    this.$saveAppsFlyer("点击获取VA");
    this.init();
  },
  methods: {
    back() {
      window["FlutterClose"].postMessage("hello");
    },
    onCopy(str) {
      let url = str;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      Toast("Copy Successfy!");
      oInput.remove();
    },
    getAmount() {
      let order = this.androidData;
      order.loan_status += "";
      let amount;
      switch (order.loan_status) {
        case "1":
        case "2":
        case "3":
        case "5":
          amount = order.amount2Account;
          break;
        case "4":
        case "6":
          amount = order.remainAmount;
          break;
        case "9":
          amount = order.reach_amount;
          break;
      }
      // if(amount.includes(",")){
      //     amount = amount.replaceAll(",","");
      // }
      // amount = 20000000;
      return amount;
    },
    init() {
      let that = this;
      that.payInfo = JSON.parse(localStorage.getItem("payInfo") || "{}");
      let data = that.payInfo;
      // 接收安卓传参
      console.log("安卓已调config", data);
      // document.getElementById("log_msg").innerHTML += ("<br\>Android调用了js函数并传递参数：" + data);
      if (typeof data == "string") {
        data = JSON.parse(data);
      }
      if (data.baseUrl) {
        data.baseUrl = data.baseUrl.replace("/api", "");
      }

      console.log("安卓已调config2", data);
      that.androidData = data;

      loanappqueryDetail({
        ...data,
      }).then(async (res) => {
        if (res.message) {
          Toast(res.message, 2000);
        }
        that.resData = res.result;
        // that.resData.repayChannels = ["oxPay"];
        // that.resData.repayChannels = ["uuPay"];
        // that.resData.repayChannels = ["oxPay", "uuPay"];
        that.curItem = that.resData.repayChannels[0];

        localStorage.setItem(
            "androidData",
            JSON.stringify({...data})
            // JSON.stringify({ ...data, ...that.resData })
        );
        console.log("that.resData", that.resData);
        console.log(that.resData.repayChannels.length, that.curItem);
        // if (data.vaType == 1 && data.repaymentMed == 1) {
        if (data.vaType == 1) {
          this.$router.push("/immediately")
          return;
        }else if (data.vaType == 2) {
          this.$router.push("/rollover")
          return;
        }


        // const params = {
        //   amount: this.getAmount(),
        //   bank_code: this.androidData.bank_code,
        //   atm_otc: 2,
        //   vaType: this.androidData.vaType,
        //   application_id: this.androidData.application_id,
        // };
        // let resss = await getva({
        //   ...that.androidData,
        //   ...params,
        // });
        // console.log("resss", resss);
        // if (resss.code == 200) {
        //   window.location.href = resss.result.va;
        // }
      });
      // window.config({
      //   amount: "1,464,000.00",
      //   bank_code: "970436",
      //   atm_otc: 1,
      //   vaType: 1,
      //   application_id: "VV3020230628000023745",
      //   timestamp: Date.now(),
      //   sign: "0f656af82eb1da33221a06d1171db265",
      //   channel: "1",
      //   pkg_name: "com.loan.starloanh5ios",
      //   user_id: "220230628000004428",
      //   app_version: "1.0.0",
      //   appversion: "1.0.0",
      //   version: "1.0.0",
      //   baseUrl: "https://h5.vivohan.com",
      //   busiNo: "VV3020230628000023745",
      // });
      window.successCallback = function () {
        that.isCallback = 1;
      };
    },
  },
};
</script>

<style lang="less" scoped>
.payChoess {
  height: 100vh;
  overflow-y: auto;
  box-sizing: border-box;

}
</style>
